import * as React from 'react'
import * as classnames from 'classnames'

import * as styles from './menu.css'

import { StoreComponent, injectStores } from '../../../store'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
// import { HashLink as Link } from 'react-router-hash-link'
import { MenuCloseButton, ExternalLinkButton, SourcesButton, ImprintButton } from '../../common/elements/buttons'
import posed from 'react-pose'
import bind from 'bind-decorator'
import { SubmenuOverlay } from './submenuOverlay'
import { Portal } from 'react-portal'
import { MenuChapter } from './menuChapter'

const kasImg = require('./kas_logo.png')

const menuProps = {
  open: { x: '0%', opacity: 1, transition: { duration: 300, ease: 'easeOut' } },
  closed: { x: '-100%', opacity: 0, transition: { duration: 300, ease: 'easeIn' } }
}

const menuPropsMobile = {
  open: { y: '-100%', transition: { duration: 300, ease: 'easeOut' } },
  closed: { y: '0%', transition: { duration: 300, ease: 'easeIn' } }
}

const Sidebar = posed.div(menuProps)
const SidebarMobile = posed.div(menuPropsMobile)

@injectStores
@observer
export class Menu extends StoreComponent {
  @observable submenuOpen = false

  element: HTMLDivElement | null = null

  @bind
  closeMenu () {
    this.store.storeCommon.menu.open = false
    this.closeSubmenu()

  }

  @bind
  openSubmenu () {
    this.submenuOpen = true
  }

  @bind
  closeSubmenu () {
    this.submenuOpen = false
  }

  @bind
  handleExpand (e: any) {
    e.stopPropagation()
  }

  @bind
  goHome () {
    if (this.store.storeRouter.location.pathname !== '/') this.store.storeRouter.push(`/`)
    else this.store.storeRouter.replace(`/`)
  }

  @bind
  handleChange (langTo: string) {
    if (langTo === 'en') {
      this.store.storeCommon.menu.language = 'en'
      localStorage.setItem('language', 'en')
    } else {
      this.store.storeCommon.menu.language = 'de'
      localStorage.setItem('language', 'de')
    }

    this.store.storyDocContent.fetchTitlePage()
    this.store.storyDocContent.fetchChapters()
    .then(() => this.store.storeRouter.replace(`/story/${this.store.storyDocContent.chapters[this.store.storyDocUI.currentSlideIdx].uid}`))
    this.store.storyDocContent.fetchTimeline()

    if (this.submenuOpen) this.closeSubmenu()
  }

  render () {
    let submenu: JSX.Element | null = null
    if (this.store.storeCommon.menu.open) {
      submenu = <Portal><SubmenuOverlay open={this.submenuOpen} onBackClick={this.closeSubmenu} /></Portal>
    }

    let kasLogo: JSX.Element | null = null
    kasLogo = <a className={styles.kasLogo} href={'http://kas.de/'} target='_blank'><img src={kasImg} alt='kas_icon'/></a>

    let burger: JSX.Element | null = null
    burger = <div className={styles.burger}>
      {this.store.breakpoints.phone && kasLogo}
      {this.store.breakpoints.phone && <span className={styles.burgerText} onClick={this.goHome}>Konrad Adenauer</span>}
      <MenuCloseButton className={styles.menuButton} onClick={this.closeMenu} />
    </div>

    let langAndSocial: JSX.Element | null = null
    const style = this.store.breakpoints.phone && this.store.storeCommon.window.height > 900 ? styles.portraitMode : undefined
    langAndSocial = <div className={styles.langAndSocial}>
                      <div className={classnames(styles.languages, style)}>
                        <div
                          className={classnames(styles.lang, this.store.storeCommon.menu.language === 'de' ? styles.current : null)}
                          onClick={() => this.handleChange('de')}
                        >D</div> |
                                        <div
                          className={classnames(styles.lang, this.store.storeCommon.menu.language === 'en' ? styles.current : null)}
                          onClick={() => this.handleChange('en')}
                        >E</div>
                      </div>
                      <div className={classnames(styles.social, style)}>
                        <a href='https://de-de.facebook.com/kasfb/' rel='noopener' target='_blank'><div className={styles.fb}/></a>
                        <a href='https://www.instagram.com/onlinekas/?hl=de' rel='noopener' target='_blank'><div className={styles.insta}/></a>
                        <a href='https://twitter.com/kasonline?lang=de' rel='noopener' target='_blank'><div className={styles.twitter}/></a>
                      </div>
                    </div>

    let footer: JSX.Element | null = null
    footer = <div className={styles.footer}>
      {this.store.breakpoints.desktop && langAndSocial}
      <ExternalLinkButton isExternal to={'https://www.konrad-adenauer.de/'} className={styles.footerLink}>konrad-adenauer.de</ExternalLinkButton>
      <ExternalLinkButton isExternal to={'http://kas.de/'} className={styles.footerLink} onClick={(e: any) => {
        e.preventDefault()
        window.open('https://kas.de/', '_blank', 'location=yes')
      }
    }>kas.de</ExternalLinkButton>
      <ExternalLinkButton isExternal to={'http://geschichte-cdu.de/'} className={styles.footerLink}>geschichte-cdu.de</ExternalLinkButton>
      <ExternalLinkButton isExternal to={'http://www.videobooks.com/'} className={styles.footerLink}>{this.store.storeCommon.menu.language === 'de' ? 'Weitere videobooks' : 'Other videobooks'}</ExternalLinkButton>
      <SourcesButton
        className={classnames(styles.footerLink, (this.store.storeCommon.menu.submenuType === 'quellen' || this.store.storeCommon.menu.submenuType === 'sources') && this.submenuOpen ? styles.activeFooterlink : null)}
        onClick={() => {
          this.openSubmenu()
          this.store.storeCommon.menu.submenuType = this.store.storeCommon.menu.language === 'de' ? 'quellen' : 'sources'
        }}
      >{this.store.storeCommon.menu.language === 'de' ? 'Quellen' : 'Sources'}</SourcesButton>
      <ImprintButton
        className={classnames(styles.footerLink, (this.store.storeCommon.menu.submenuType === 'impressum' || this.store.storeCommon.menu.submenuType === 'imprint') && this.submenuOpen ? styles.activeFooterlink : null)}
        onClick={() => {
          this.openSubmenu()
          this.store.storeCommon.menu.submenuType = this.store.storeCommon.menu.language === 'de' ? 'impressum' : 'imprint'
        }}
      >{this.store.storeCommon.menu.language === 'de' ? 'Impressum' : 'Imprint'}</ImprintButton>
      <ImprintButton
        className={classnames(styles.footerLink, (this.store.storeCommon.menu.submenuType === 'data-privacy' || this.store.storeCommon.menu.submenuType === 'privacy-policy') && this.submenuOpen ? styles.activeFooterlink : null)}
        onClick={() => {
          this.openSubmenu()
          this.store.storeCommon.menu.submenuType = this.store.storeCommon.menu.language === 'de' ? 'data-privacy' : 'privacy-policy'
        }}
      >{this.store.storeCommon.menu.language === 'de' ? 'Datenschutz' : 'Privacy policy'}</ImprintButton>
      {this.store.breakpoints.phone && langAndSocial}
      {this.store.breakpoints.desktop && burger}
    </div>

    const chapters = []
    for (const chapter of this.store.storyDocContent.chapters) {
      let isActive: boolean = this.store.storyDocUI.currentSlideIdx === chapter.idx || false

      chapters.push(<MenuChapter
        // to={`/story/${chapter.id}`}
        key={chapter.id}
        chapter={chapter}
        isActive={isActive}
      />
      )
    }

    let content: JSX.Element | null = null
    if (this.store.breakpoints.desktop) {
      content = <div className={styles.progressBar} style={{ height: this.store.storeCommon.window.height }}>
        <div className={styles.sidebar}>{kasLogo}{footer}</div>
        { chapters }
        { submenu }
      </div >
    } else {
      content = <div
        className={ styles.progressBar }
        ref={elem => this.element = elem}
        // style={this.element && this.element.clientHeight < this.store.storeCommon.window.height ? { height: '100%' } : undefined}
      >
        { burger }
        { chapters }
        { footer }
        { submenu }
      </div >
    }

    if (this.store.breakpoints.desktop) {
      return (
        <Sidebar
          pose={ this.store.storeCommon.menu.open ? 'open' : 'closed' }
          key='menu' className={ styles.menuContainer }
          initialPose='closed'
          style={{ height: this.store.storeCommon.window.height }}
        >

        { content }

        </Sidebar >
      )
    } else {
      return (
        <SidebarMobile
          pose={ this.store.storeCommon.menu.open ? 'open' : 'closed' }
          key='menu' className={ styles.menuContainer }
          initialPose='closed'
          style={{ height: this.store.storeCommon.window.height, top: this.store.storeCommon.window.height }}
        >
        { content }
        </SidebarMobile >
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/header/menu.tsx